import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type EmptyStateProps = {
  message: React.ReactNode | string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
};

/**
 * Componente reutilizável para estados vazios
 */
export function EmptyState({ message, actionLabel, onAction, className }: EmptyStateProps) {
  return (
    <div className={cn("py-8 text-center", className)}>
      {typeof message === "string" ? (
        <p className="mb-4 text-muted-foreground">{message}</p>
      ) : (
        message
      )}
      {actionLabel && onAction && (
        <Button variant="outline" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
